import React from "react";
import TopHeader from "../../Components/TopHeader";
import EmailSubscription from "../../Components/EmailSubscription";
import Footer from "../../Components/Footer";
import { Link } from "react-router-dom";
const TermsOfService = () => {
    return (

        <>
        <TopHeader />
        <div
  className="col-lg-8 mx-auto terms-of-service-section protected-content main-container terms-wrapper -with-cta-banner"
  draggable="false"
>
  <h1 className="my-5">
    Terms of Service
  </h1>
  <article className="text-justify protected-content">
    <div className="c13 c27">
      <p className="c20">
        <span className="c3 c38">
          Last updated: December 2022
        </span>
      </p>
      <p className="c17">
        <span className="c8">
          ABOUT:
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture is the fashion marketplace changing the way we wear. Our mission is to reinvent ownership by providing all the short-cuts to a sustainable wardrobe through renting, lending, monthly refreshes, purchase or sale of pre-owned clothing via our website{' '}
          <span className="c3 c13">
            <Link
              className="c9"
              to="https://www.circularcouturecollective.com/"
              target="_blank"
            >
              www.circularcouture.com
            </Link>
          </span>
          {' '}and mobile application.
        </span>
      </p>
      <p className="c17">
        <span>
          To find out more about when and why we collect your personal information, how we use it, and how we keep it secure, please refer to our{' '}
        </span>
        <span className="c3">
          <Link
            className="c9"
            to="https://www.circularcouturecollective.com/privacy-policy"
            target="_blank"
          >
            Privacy Policy
          </Link>
        </span>
        . For information about how we use cookies, please refer to our{' '}
        <span className="c3">
          <Link
            className="c9"
            to="https://www.circularcouturecollective.com/cookie-policy"
            target="_blank"
          >
            Cookie Policy
          </Link>
        </span>
        <span>
          .
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          All users of our services are required to read, accept and agree to comply with these terms and conditions (including the terms of the{' '}
        </span>
        <span className="c3">
          <Link
            className="c9"
            to="https://www.circularcouturecollective.com/privacy-policy"
            target="_blank"
          >
            Privacy Policy
          </Link>
        </span>
        {' '}and{' '}
        <span className="c3">
          <Link
            className="c9"
            to="https://www.circularcouturecollective.com/cookie-policy"
            target="_blank"
          >
            Cookie Policy
          </Link>
        </span>
        ) and any third-party terms and conditions referred to within these terms and conditions or referred to on our website or mobile application (collectively, the "
        <strong>
          Terms
        </strong>
        "). If you do not wish to accept any aspect of the Terms, you should not register and we strongly recommend you stop using our services immediately.
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture reserves the right, at its sole and absolute discretion, to accept or reject any membership application for an account to use our services.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture reserves the right to make changes to the services provided by circularcouture and to these Terms which will not materially affect your use of the services. circularcouture strongly recommends that you revisit these Terms each time you use the services to familiarise yourself with any amendments. Acceptance of any amendments to services provided by circularcouture and/or the Terms will be inferred from your continued use of the services. In the event that we make any significant changes to our services and/or the Terms, we will notify you in writing and provide you with an opportunity to cease use of the services before the changes take effect.
        </span>
      </p>
      <p className="c17">
        <span className="c8">
          The definitions outlined below apply throughout the Terms:
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Booking Date": the date on which you placed the order for the rental of a product, this date will be outlined in your confirmation email and available on your account dashboard.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Buyer": The purchaser of pre-loved clothing via the circularcouture Platform.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Cancellation Charge": a charge equating to 30% of the Rental Fee which is payable by a Renter to circularcouture to cover administrative costs associated with the cancellation of a rental.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Content": any photos, text or any other information posted to the circularcouture Platform or the circularcouture social media platforms by circularcouture or Members.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Cookie Policy":{' '}
          <span className="c3">
            <Link
              className="c9"
              to="https://www.circularcouturecollective.com/cookie-policy"
              target="_blank"
            >
              www.circularcouture.com/cookie-policy{' '}
            </Link>
          </span>
          <span />
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Damage Protection": an optional service provided by circularcouture to its Renters to repair normal wear and tear of products, including without limitation, minor stains, rips, missing beads, stuck zippers or other minor damage to a product in consideration for the Damage Protection Charge.{' '}
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Damage Protection Charge": an optional AU$7.50 charge payable by a Renter to circularcouture in consideration for Damage Protection.{' '}
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Delivery Fee": the cost for each product to be delivered as part of the Services.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Fee Avoidance": any action taken by a Member to directly or indirectly avoid paying the Service Fee. This includes, but shall not be limited to, any steps taken by a Member in their own capacity or in conjunction with other Members to: (i) direct Users or Members to an alternative site performing services similar to the Services; or (ii) communicate directly with another User or Member with a view to circumventing the Service Fee and/or the circularcouture Offering.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "General Terms": the terms and conditions of use which apply to all Users.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "circularcouture": circularcouture Limited, we, us, our.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "circularcouture Offering": means the circularcouture Platform and services and Content provided through the circularcouture Platform, including, without limitation, services facilitating peer-to-peer fashion rental, managed rental, lending, and the purchase and sale of pre-owned clothing.{' '}
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "circularcouture Platform": the website{' '}
          <span className="c3 c13">
            <Link
              className="c9"
              to="https://www.circularcouturecollective.com/"
              target="_blank"
            >
              www.circularcouture.com
            </Link>
          </span>
          {' '}and the mobile application made available by circularcouture.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Intellectual Property Rights": patents, utility models, rights to inventions, copyright and neighbouring and related rights, trademarks and service marks, business names and domain names, rights in get-up and trade dress, goodwill and the right to sue for passing off or unfair competition, rights in designs, database rights, rights to use, and protect the confidentiality of, confidential information (including know-how and trade secrets) and all other intellectual property rights, in each case whether registered or unregistered and including all applications and rights to apply for and be granted, renewals or extensions of, and rights to claim priority from, such rights and all similar or equivalent rights or forms of protection which subsist or will subsist now or in the future in any part of the world.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Late Fees" - the daily Renter charge for the late return of a Product
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Lend": the lending of a product by a Lender to a Renter via the circularcouture Offering in consideration for the Rental Fee and "lending" shall be construed accordingly.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Lender": a Member who makes product(s) available for rent via the circularcouture Platform and "Lenders" shall be construed accordingly.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Listing": the listing of a product by a Lender on the circularcouture Platform and "
          <strong>
            List
          </strong>
          " shall be construed accordingly.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Mediation Costs": In the event that substantial costs are incurred as a result of circularcouture’s provision of mediation services, circularcouture may invoice a reasonable reimbursement in respect of these costs.{' '}
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Member(s)": any individual who has registered to use the Services and been accepted by circularcouture as a member.{' '}
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Payment Method": means the credit or debit card associated with your circularcouture account or used to complete the Service.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Privacy Policy":{' '}
          <span className="c3">
            <Link
              className="c9"
              to="/privacy-policy"
              target="_blank"
            >
              www.circularcouture.com/privacy-policy{' '}
            </Link>
          </span>
          <span />
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Product": a product shall include but shall not be limited to: womenswear clothing and accessories and “products” shall be construed accordingly.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Purchase Price": a product shall include but shall not be limited to: womenswear clothing and accessories and menswear clothing and "
          <strong>
            products
          </strong>
          " shall be construed accordingly.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Referral Rules": the additional terms incorporated into these Terms that apply to referrals can be found{' '}
          <span className="c3 c13">
            <Link
              className="c9"
              to="https://www.circularcouturecollective.com/terms-of-service#refer_a_friend"
            >
              here
            </Link>
          </span>
          .
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Rent/Renting/Rental": the renting of a product or products by a Renter via the circularcouture Platform in consideration for the Rental Fee.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Rental End Date": means 12pm (noon) on the date upon which the rental of a product expires and the date indicated as such in the Renter’s confirmation email and account dashboard. This date is referred to as the "in the post by" date on the circularcouture Platform.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Rental Fee": the fee to rent a Product.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Rental Period": means the number of days a product is rented for and shall be measured from the Rental Start Date to the Rental End Date.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Rental Request": a request made by a Member to rent a product for the specified Rental Period.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Rental Start Date": the date upon which the rental of a product begins (and for the avoidance of doubt, includes bank holidays, weekends and any other public holidays), this date will be outlined in your confirmation email and available on your account dashboard.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Renter": a Member who rents a product on the circularcouture Platform.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Rental Terms": the additional terms incorporated into these Terms that apply to Renters which can be found{' '}
          <span className="c3 c13">
            <Link
              className="c9"
              to="https://www.circularcouturecollective.com/terms-of-service#rental_terms"
            >
              here
            </Link>
          </span>
          .
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Replacement Value": a reasonable estimate of the current market value of a product by circularcouture. circularcouture shall determine the value in its sole discretion and its determination shall be final and binding.{' '}
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Review": a brief summary of a Renter or Lender’s experience of Renting or Lending or a Buyer or Seller’s experience of purchasing or selling a product (as applicable) via the circularcouture Offering.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Sale Terms": the additional terms incorporated into these Terms that apply to the sale of a product which can be found{' '}
          <span className="c3 c13">
            <Link
              className="c9"
              to="https://www.circularcouturecollective.com/terms-of-service#sale_terms"
            >
              here
            </Link>
          </span>
          .
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Security Deposit": means the security deposit applied to products over a certain value amount and determined by circularcouture or the Lender of a product, the sum of which shall be held on the Renter’s payment card until the product is returned and confirmed to be in good condition with no damage.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Seller": The seller of pre-loved clothing via the circularcouture Platform.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Service": the renting, lending, purchase or sale of pre-owned clothing by a Member via the circularcouture Offering.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Service Fee": shall mean:,
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          (a) as a Lender, you agree to pay circularcouture a commission payment equating to 15% of the Rental Fee;
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          (b) as a Renter, you agree to pay circularcouture a commission payment equating to 15% of the Rental Fee; and / or
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          (c) as a Seller, you agree to pay circularcouture a commission payment equating to 12% of the Purchase Price, excluding delivery costs.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          For the avoidance of doubt, the Service Fee shall be in addition to the Rental Fee or Purchase Price (as applicable) and not comprised within it.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Terms": means these terms and conditions, the Renters’ Terms, the Lenders’ Terms, the third-party terms and conditions which are incorporated into these terms and conditions by reference, the Privacy Policy and the Cookie Policy.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Third-Party Content": means links or references to third party websites, products, services, materials or content.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Trader Seller": a Seller acting for purposes relating to that person’s trade, business, craft or profession, whether acting personally or through another person acting in the trader’s name or on the trader’s behalf (as specified as Managed on the circularcouture Platform).
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          "Users": refers to Members and visitors to the circularcouture Platform who are not registered as Members and "User" shall be construed accordingly.
        </span>
      </p>
      <p className="c17">
        <span className="c8">
          WHO WE ARE:
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Unless expressly provided otherwise, the role of circularcouture shall be limited to providing the intermediary platform between Members, circularcouture will not act as a Lender or Seller and at no point in time will circularcouture become the owner of a product. At all times, Members act for and on behalf of themselves and never as an agent or representative of circularcouture. circularcouture is not a party to any Service between Members and hereby disclaims all liability in respect thereof. The circularcouture Offering is owned and operated by circularcouture Limited, a private limited company registered in England and Wales under company number 11262189 and with a registered office at 85 Great Portland Street, First Floor, London, W1W 7LT.
        </span>
      </p>
      <p className="c17">
        <span className="c8">
          WHEN YOU USE THE circularcouture OFFERING:
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          By selling, lending, buying, or renting a product, you understand that you are entering into a binding agreement and hereby agree and undertake to abide by the Terms for the duration of the Service.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If circularcouture is sued due to an action or inaction by a Member (including a breach of these Terms) then we have the right, at our discretion, to request that you indemnify us (i.e. cover all our costs including legal fees) and hold us harmless from any legal claim or demand for expenses or costs that arises as a result and which are reasonably incurred by us. Where we decide to conduct the defence of such claim, you agree to assist us as reasonably requested.
        </span>
      </p>
      <p className="c17">
        <span className="c8">
          CHANGES:
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          We reserve the right to make changes to the circularcouture Offering and to these Terms to (without limitation): reflect changes in relevant laws and regulatory requirements, implement minor technical adjustments and make improvements to the circularcouture Offering. These changes will not materially affect your use of the circularcouture Offering however we do recommend that you revisit these Terms each time you use the circularcouture Offering to familiarise yourself with any amendments.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          We are always looking at new ways and innovative features to improve the circularcouture Offering. Whilst implementing these updates, we may need to reset, stop offering or supporting a particular aspect or feature of the circularcouture Offering. These changes may affect your past activities, current features and Content you have posted and any other information you have submitted to the circularcouture Platform. Once we have made the changes to any part of the Services, your acceptance will be inferred from your continued use of the circularcouture Offering.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If we intend to make any significant changes to the circularcouture Offering or these Terms, we will notify you in advance in writing and provide you with an opportunity to cease use of the circularcouture Offering before the changes take effect.
        </span>
      </p>
      <p className="c17">
        <span className="c8">
          ACCESS AND AVAILABILITY:
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          We will use all reasonable endeavours to ensure that the circularcouture Offering is fully operational at all times, however, we do not guarantee that the circularcouture Offering will be uninterrupted.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Access to the circularcouture Offering is permitted on an "as is" temporary basis. We may suspend, withdraw, discontinue or change all or any part of the circularcouture Offering without notice. We will not be liable to you if the circularcouture Offering is unavailable at any time or for any period of time.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You are responsible for making all arrangements necessary to facilitate access to the circularcouture Offering. You will also be responsible for ensuring that all persons who access the circularcouture Offering through your internet connection are aware of these Terms and that said persons remain in compliance with these Terms at all times.
        </span>
      </p>
      <h2 className="c17">
        <span className="c8">
          GENERAL TERMS
        </span>
      </h2>
      <ol
        className="c1 lst-kix_list_1-0 start"
        start="1"
      >
        <li className="c10">
          <span>
            USE OF circularcouture PLATFORM
          </span>
        </li>
      </ol>
      <ol
        className="c1 lst-kix_list_A-0 start"
        start="A"
      >
        <li className="c10">
          <span className="c8">
            Registration
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          To access and use the full range of circularcouture Offerings, you will be required to set up an account and register to become a Member. You must become a Member to rent, buy, lend, or sell a product through the circularcouture Platform.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You will be required to supply certain information, including personal information, in order to complete the registration form successfully. You may create an account by using an email address and password or by connecting through a social media account (e.g. Facebook and Google). You are the only person authorised to access and use your account and your account is non-transferable. circularcouture is under no obligation to accept any individual as a Member and reserves the right to accept or reject any membership application at its sole and absolute discretion.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You will also have the opportunity to sign up for marketing emails to hear about all of the latest news and styles at circularcouture (you can unsubscribe at any time by clicking the link in any emails you receive from us). For more information about how we use your personal information, we recommend that you review circularcouture’s Privacy Policy{' '}
          <span className="c3">
            <Link
              className="c9"
              to="/privacy-policy"
            >
              here
            </Link>
          </span>
          .
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You must be over 18 years of age to create a circularcouture account and you represent and warrant that you are over 18 years of age and have the legal capacity in the United Kingdom to enter into a legally binding agreement. For the avoidance of doubt, parents or legal guardians may not agree to these Terms on behalf of children under the age of 18 in order to facilitate the renting of products via the circularcouture Offering.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If you are registering an account on behalf of a company or other entity, you represent and warrant that:
        </span>
      </p>
      <ul className="c31 lst-kix_list_2-0 start">
        <li className="c51">
          <span className="c0">
            you have the necessary authority and capacity to bind the company or the entity (as applicable);
          </span>
        </li>
        <li className="c51">
          <span className="c0">
            you are entitled to give us the licenses and permissions required under these Terms; and
          </span>
        </li>
        <li className="c51">
          <span className="c0">
            all information and details provided by you to us at the point of registration or otherwise are true, accurate and up to date in all respects.
          </span>
        </li>
      </ul>
      <p className="c17">
        <span className="c0">
          You can update or correct your personal details or the details in respect of a company or other entity (as applicable) at any time in your account dashboard or by emailing us at{' '}
          <span className="c3">
            <Link
              className="c9"
              to="mailto:contact@circularcouturecollective.com"
            >
              contact@circularcouture.com
            </Link>
          </span>
          .
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You are responsible for maintaining the confidentiality of your account details and for any activities that occur under your account. If you have any concerns that your account has been misused, you should contact us at{' '}
          <span className="c3">
            <Link
              className="c9"
              to="mailto:contact@circularcouturecollective.com"
            >
              contact@circularcouture.com
            </Link>
          </span>
          .
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You represent and warrant that you have all relevant rights, licenses and/or approvals in relation to any Content you post on the circularcouture Platform.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture reserves the right to deactivate an account at any time, including, without limitation, if it is determined that a Member has violated these Terms or any aspect thereof.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Unless expressly authorised by circularcouture in writing, you may only register one (1) account.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          A public username is automatically created at registration using a combination of characters from your forename and surname. Your username is visible to all Users. You can change your username at any time via your dashboard provided that the username is not already in use by another Member. Members can use the "Search" tool to search for other Members by (i) username; or (ii) forename. The "Search" tool does not facilitate searches by email address.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture reserves the right in its sole and absolute discretion to refuse to grant a User a particular username, including if the username is: impersonating someone else, protected by a trademark or other third-party intellectual property rights, vulgar or offensive to any individual or group of individuals, unsuitable, discriminatory, threatening, abusive, defamatory, obscene, inappropriate, infringing, indecent or otherwise does not comply with these Terms or the ethos of circularcouture. Please note that this list of circumstances is not exhaustive.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If circularcouture needs to contact you in relation to the circularcouture Offering, it will be in accordance with the preferences and contact details indicated by you at registration or checkout. If you have indicated that your preferred method of contact is via telephone, we, and any other third parties appointed to fulfil the provision of the circularcouture Offering, may contact you by telephone call or text message, including by an automatic telephone dialling system. Standard message and data rates charged by your mobile carrier may apply to the text messages we send you.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Changes to information
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You represent and warrant that all information provided at the point of registration is truthful and accurate and you undertake to update any inaccurate information as soon as reasonably practicable.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span
            className="c8"
            id="refer_a_friend"
          >
            Refer a friend
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          Our "Refer a Friend" programme allows any Member of our community to refer another person to sign up to the circularcouture Platform. Once that person has registered to become a Member, they will receive an incentive to transact on the circularcouture Platform. Once they have successfully transacted on the circularcouture Platform, the referrer will receive a reward for the successful referral.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          The referrer and the referee shall be granted certain rights in accordance with the provisions of the current referral business model.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            circularcouture Offering
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          Upon the successful registration of your account with circularcouture and subject always to compliance with these Terms, circularcouture grants you a revocable, non-transferable, non- exclusive, non-sublicensable, license to access and use the circularcouture Offering for your personal use.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You agree to indemnify circularcouture against any claims made or threatened against circularcouture by another person arising as a result of your breach of the Terms.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Ancillary circularcouture Offering
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c10">
          <span className="c8">
            Promotional activities
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          Any sweepstakes, contests, raffles, surveys, games, or similar promotions (collectively, "Promotions") made available through the circularcouture Offering may be governed by rules that are separate from these Terms. If you participate in any Promotions, please review the applicable rules. If the rules for a Promotion conflict with these Terms, the Promotion rules will take precedence.
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c10">
          <span className="c8">
            "Offer To Buy"
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          The "Offer To Buy" functionality available on the circularcouture Platform enables a Buyer to confidentially negotiate the price of a product by sending an offer to the Seller, who may either accept it or reject it, or make a counter-offer to the Buyer. If a sale is agreed, the Sale Terms shall apply to the sale of that Product.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Unauthorised use of the circularcouture Offering{' '}
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          Please notify us immediately if you learn or have reason to suspect that unauthorised use of your account or any security incident has occurred, is occurring, or is likely to occur. You will be responsible for maintaining the confidentiality and secrecy of your account login details and shall be fully and solely responsible for all activities that occur on your account.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You acknowledge and accept that your use of the circularcouture Offering is subject at all times to compliance with these Terms and you hereby agree and undertake not to:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            post or transmit any Content, information or other materials on the circularcouture Platform that are, or which circularcouture considers in its sole discretion to be, unlawful, inappropriate, indecent, harmful, threatening, abusive, harassing, defamatory, vulgar, offensive, obscene, pornographic, hateful or threatening to any group defined by race, religion, gender, national origin or sexual orientation, lewd, lascivious, violent, harassing or otherwise objectionable, including without limitation, expressions of bigotry, prejudice, racism, hatred or profanity;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            introduce to the circularcouture Platform or distribute any viruses, trojans, worms, logic bombs and/or any other material which is malicious or technologically harmful;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            display material on the circularcouture Platform that exploits children under the age of eighteen (18);
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            copy, reproduce, republish, download, post, broadcast, record, transmit, commercially exploit, edit, communicate to the public, or otherwise distribute any Content, web pages or materials available on the circularcouture Platform and owned by circularcouture or a third party save with the prior written consent of circularcouture;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            infringe the Intellectual Property Rights of circularcouture or any third party;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            post, collect or disclose on the circularcouture Platform any personally identifying information (including account names) or private information about children or any third parties without their consent (or their parent's consent in case of a child under eighteen (18) years of age);
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            post or transmit any unsolicited advertising, promotional materials, or any other forms of solicitation on the circularcouture Platform, including without limitation, solicitations of credit card numbers, or promotions of raffles or contests;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            violate these Terms or any applicable domestic or international laws or regulations;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            use the circularcouture Offering to develop a service or product which competes with any aspect of the business of circularcouture;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            attempt to gain unauthorised access to the circularcouture Platform, the server on which the circularcouture Platform is stored, or any server, computer or database connected to the circularcouture Offering;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            attack the circularcouture Offering or any aspect thereof via a denial-of-service attack or a distributed denial-of service attack; a breach of this provision is a criminal offence under the Computer Misuse Act 1990 and we will report any such breach to the relevant law enforcement authorities and cooperate with those authorities by disclosing your identity to them;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            use the member-to-member communication system on the circularcouture Platform to send content that violates these Terms or constitutes spam of any kind; we reserve the right to scan internal messages between Members to check for spam, phishing, viruses and other malicious, prohibited or illegal behaviours or content (please note that internal messages sent via the circularcouture Platform are not stored indefinitely and circularcouture disclaims all liability for reliance placed on said storage);
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            sell or lend any counterfeit products or otherwise infringe the copyright, trademark or other rights of third parties;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            write, post and/or share untruthful, misleading, false or inaccurate Reviews;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            use the circularcouture Offering to intentionally deceive other Users;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            repeatedly cancel rentals;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            engage in any activity which constitutes Fee Avoidance (which shall be determined by circularcouture in its sole discretion);{' '}
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            engage in any activities which are illegal, dishonest or fraudulent;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            collect information about other Users or post information on the circularcouture Platform about other Users, including email addresses, postal addresses, phone numbers, credit card or banking information or similar information without their explicit consent;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            impersonate any person or misrepresent your affiliation with a person or entity;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            attempt to or permit any third party to use any device, software, malicious code or destructive routine intended to damage or otherwise interfere with the proper functioning of the circularcouture Offering, including without limitation, servers, third-party services or networks connected to the circularcouture Offering or security measures used in connection with the circularcouture Offering;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            use any robot, spider, scraper or other automated means to access the circularcouture Offering and/or collect data for any purpose;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            take any action that interferes with another User’s use of the circularcouture Offering or the proper functioning of the circularcouture Offering;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            attempt to or engage in actions which might reasonably cause loss to a User or to circularcouture;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            attempt to use or continue to use the circularcouture Offering if you have been suspended or banned from use;{' '}
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            attempt to or engage in actions to reverse engineer, decompile, disassemble, translate, derive or interfere with the source code for the circularcouture Platform; or
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            use the circularcouture Offering in a manner which circularcouture considers in its sole discretion to be harmful to the business of circularcouture.
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          If circularcouture determines, at all times acting reasonably, that any of the activities listed at (i) to (xxvii) above have occurred, this will constitute a material breach of these Terms. circularcouture reserves the right to take any or several of the actions outlined immediately below. circularcouture may:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            revoke your license to use the circularcouture Offering, such revocation will occur immediately without further notice to you;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            cancel any existing Services which you are party to;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            refuse to List any further products pertaining to you;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            remove any Reviews or Content pertaining to you from the circularcouture Offering; and/or
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            restrict, suspend or terminate your use of the circularcouture Offering.
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Account security
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          The circularcouture Platform contains a feature which allows you to remain logged into your account so that you can log in automatically and conveniently each time you access the circularcouture Platform. You acknowledge and agree that you will be responsible for any damage or loss to circularcouture or the circularcouture Offering arising from or relating to unauthorised access to the circularcouture Offering from your account and you hereby agree to indemnify circularcouture against any claims made or threatened against circularcouture, or any loss or damage arising from or relating to such unauthorised access. circularcouture will have no liability to you or any third party for damage or loss related to or arising from such unauthorised access or use.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Interruptions to the circularcouture Offering
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          The circularcouture Offering may be subject to limitations, delays and other problems inherent in the use of such communications facilities and you acknowledge that the circularcouture Offering:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            will not be uninterrupted or error-free;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            may experience delays and contain inaccuracies;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            may become unavailable from time to time due to maintenance requirements, malfunction or otherwise; and{' '}
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            will not be free from vulnerabilities or viruses.
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          circularcouture will not be responsible or liable to you for any loss or damage arising from or relating to delays, delivery failures, or any other loss or damage arising from or relating to the transfer of data over communications networks and facilities, including the internet, viruses, worms or other programmes designed to impair the circularcouture Offering.
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span>
            INTELLECTUAL PROPERTY
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You acknowledge and accept that your use of the circularcouture Offering does not confer on you any Intellectual Property Rights owned by circularcouture or its licensors (as applicable) and you hereby agree and undertake that you shall not attempt to register, register, or use, any trademarks, domain names, trade names or derivations thereof that may imitate or are similar enough to those owned by circularcouture as to be confusing and you shall not, under any circumstances, attempt to or harm, tarnish or damage the circularcouture brand or perception of circularcouture in any way, knowingly or otherwise.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          We are the owner or licensee of all Intellectual Property Rights in the circularcouture Offering, the Content and in the material published on the circularcouture Platform (including text, graphics, logos, icons, images, sound clips, video clips, data compilations, page layout, underlying code and software). Those works are protected by copyright laws and treaties around the world. All such rights are reserved.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Unless any of the exceptions detailed in Chapter III of the Copyright Designs and Patents Act 1988 apply, Users agree not to otherwise reproduce, duplicate, copy, resell or in any other manner re-use or exploit any part of the circularcouture Offering or Content on the circularcouture Platform unless circularcouture has provided its prior written consent to do so.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You acknowledge and accept that you have no Intellectual Property Rights arising from the circularcouture Offering or the Content and you hereby agree and undertake that you will not use the circularcouture Offering or the Content save as in accordance with these Terms. It is your sole responsibility to ensure you have all necessary rights and licenses to use and/or submit materials and Content to the circularcouture Platform.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You must not extract or otherwise use any Content or data on the circularcouture Platform for commercial purposes.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0 start">
        <li className="c10">
          <span className="c8">
            circularcouture Content
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          All Content and information available through the circularcouture Offering, including but not limited to, product descriptions and specifications, product photos, advice from stylists and photos are available to you on an "as is" basis and is to be used for general information purposes only.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Such information is provided on an anonymous basis, without any knowledge as to your identity or specific circumstances. We will update the Content as we deem appropriate and without advance notice to you.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Third-Party Content
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          The circularcouture Offering may contain links or references to non-circularcouture websites, products, services or other materials or Content. This Third-Party Content is provided to you as a convenience, and circularcouture is not responsible for any Third-Party Content or the actions of those that provide or use such Third-Party Content. Any Third-Party Content is independent from circularcouture, and circularcouture has no control over the Third-Party Content.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          In addition, a link to any Third-Party Content does not imply that circularcouture endorses, approves of or accepts any responsibility for the Third-Party Content or its provider, or vice versa. You acknowledge and agree that we will not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by, in connection with or resulting from your use of or reliance on any such Third-Party Content. We strongly encourage you to review any separate terms and conditions of use, privacy policies and cookie policies governing these third-party websites and Third-Party Content.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Content usage by Users
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          Save for Content uploaded by you, no part of the circularcouture Offering or Content may be reproduced or transmitted in any form, by any means, electronic or mechanical, including photocopying and recording, except that circularcouture authorises you to view, copy, download, and print Content (such as press releases and FAQs) that are available on the circularcouture Platform, provided that: (a) you use the Content solely for your personal, non- commercial, informational purposes; (b) you do not modify the Content; and (c) you do not remove any copyright, trademark, and other proprietary notices on the Content.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Listings and Content uploaded by Members
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You represent and warrant that you own all Intellectual Property Rights in the Content and its publication will not infringe upon the rights of any third party (including Intellectual Property Rights).
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You hereby agree to indemnify circularcouture against, and shall pay to circularcouture a sum equal to, all liabilities, costs, expenses, damages and losses (including but not limited to any direct, indirect or consequential losses, loss of profit, loss of reputation and all interest, penalties and legal costs (calculated on a full indemnity basis)) suffered or incurred by circularcouture arising out of or in connection with an infringement of the rights of any third party (including Intellectual Property Rights).
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          By creating a Listing or uploading Content to the circularcouture Platform, you acknowledge and agree that you are granting circularcouture a worldwide, non-exclusive, royalty-free, irrevocable, sublicensable, transferable and perpetual license to modify, compile, combine with other Content, copy, record, synchronise, transmit, translate, format, distribute, publicly display, publicly perform, and otherwise use or exploit your Content as reasonably necessary to provide, advertise and promote the circularcouture Offering.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          In relation to Content uploaded by you to the circularcouture Platform, you acknowledge and agree that:{' '}
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            all photographs must be true, accurate and un-edited photographs of the product(s);
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            circularcouture may modify the presentation of the photographs of the products (e.g. by resizing the photographs or removing the background of a product so that it appears over a white background);
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            the Content will be accessible by others;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            you are waiving any rights to confidentiality, including without limitation, any personally identifying information contained in the Content;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            Content may be displayed and shared in online and offline advertisements, emails, and on other websites and applications to promote circularcouture and increase the visibility of the circularcouture Offering; and
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            the Content is wholly your responsibility.
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          circularcouture reserves the right to remove any photographs which it considers in its sole discretion to be:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            tampered with;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            of less than acceptable quality;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            unfit for the purpose of accurately displaying the product(s); or
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            infringing the Intellectual Property Rights of any third party.
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          circularcouture’s decision to remove a photograph shall be final.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You understand that the Content you upload will not be constantly monitored by circularcouture and you hereby agree and undertake not to upload Content which is unsuitable, offensive, discriminatory, threatening, abusive, defamatory, obscene, inappropriate, infringing, indecent or which does not comply with these Terms. If circularcouture determines that the Content is inappropriate for any of the aforementioned reasons, it reserves the right to remove the Content immediately without any further notice to you.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture may be required to obtain additional information from third parties in respect of a Listing if a product is uploaded without all requisite details, including without limitation, specifications, images, and additional descriptions. circularcouture reserves the right to amend a Listing to include additional details and shall not be obliged to provide you with the opportunity to approve any changes to the Listing in advance. circularcouture shall use its reasonable endeavours to ensure the accuracy of any additional information but shall not be liable for any inaccuracies or any losses or damages resulting therefrom.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You acknowledge and agree that circularcouture shall not be liable for any loss, damage or liability resulting from your reliance on Content posted on the circularcouture Platform by other Users and any reliance thereon is entirely at your own risk.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If any of the Content posted or submitted to the circularcouture Offering by another User makes you feel threatened, discriminated, abused or otherwise uncomfortable, or if you believe any such Content is offensive or otherwise breaches these Terms, please notify us at{' '}
          <span className="c3">
            <Link
              className="c9"
              to="https://help.circularcouturecollective.com/hc/en-us/requests/new"
              target="_blank"
            >
              https://help.circularcouturecollective.com/hc/en-us/requests/new
            </Link>
          </span>
          <span>
            .
          </span>
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            If circularcouture determines, in its sole discretion, that: the description of a product is incorrect or inaccurate (due to negligence, misrepresentation or otherwise);
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            you have fraudulently misrepresented the true description of a product; or
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            you have wilfully concealed the true description of a product, (the "Offending Content"),
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          without any delay or notice, circularcouture may:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            promptly remove (or ask you to promptly remove) the Offending Content from the circularcouture Platform;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            permanently or temporarily restrict your ability to upload any additional Content to the circularcouture Platform;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            restrict your access to the circularcouture Offering;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            temporarily or permanently disable your access to the circularcouture Offering;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            terminate any pending Services; and/or
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            take any other action which it considers necessary to remedy the breach.
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          The order of Listings which appear in search results is not indicative of a preference for any particular Listing, Lender or Seller by circularcouture and is dependent on various factors, including without limitation, the search parameters employed by a Renter or Buyer, the price of the product, availability of the product, prior cancellations and Reviews.
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span>
            FEES AND CHARGES
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          All fees are payable in British Pound Sterling (AU$) and are subject to change over time, any amendments to fees will be updated and reflected on the circularcouture Platform.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          We work with Stripe to manage our secure payment process and you acknowledge and consent to us sharing your information with Stripe for the purposes of providing the circularcouture Offering. From time to time, Stripe may require further identification checks and you will be required to provide the further information requested to ensure your continued use of the circularcouture Offering.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Members are solely responsible for any obligations they may have to pay any applicable taxes and make any required reporting to tax authorities, including but not limited to, VAT and other sales, rental, tourist, income or other taxes.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If you do not post the product back before 12pm (noon) on the Rental End Date, you acknowledge and agree that circularcouture may, in its sole discretion, charge your Payment Method with any number of the following fees:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            the applicable Rental Fee pro rata to the number of additional days you keep the product;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            all applicable taxes to the Service; and
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            any reasonable legal expenses incurred by circularcouture in retrieving the product
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          The funds required to cover such charges will be taken from your bank account without your prior consent being sought.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          All fees are payable in British Pound Sterling (AU$) and are subject to change over time; any amendments to fees will be updated and reflected on the Platform.
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span>
            MEMBERS' LIABILITY
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You are responsible for having sufficient funds available to replace lost or damaged product(s) up to the sum of the Replacement Value of each product. If you are unsure what the Replacement Value of a product is, please contact circularcouture for the Replacement Value before booking your rental.{' '}
          <strong>
            DO NOT RENT A PRODUCT UNLESS YOU HAVE SUFFICIENT FUNDS TO COVER THE REPLACEMENT VALUE
          </strong>
          .
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture has the sole and absolute discretion to determine an appropriate Replacement Value for any product, the figure determined by circularcouture shall be binding.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          In the event of the loss or damage of a product, circularcouture shall be entitled to charge your Payment Method with an amount per damaged or lost product up the Replacement Value of each product. Funds will be taken from your account to cover outstanding charges without your prior permission being sought and you hereby consent and authorise circularcouture, at all times acting reasonably, to do so in these circumstances.{' '}
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture may contract a debt collector or file a claim via the courts to collect any outstanding payment that you have refused to pay for the damage or loss of products and all reasonable expenses incurred in the process of recouping the outstanding sums shall be added to the debt that we are collecting from you.
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span>
            circularcouture'S LIABILITY
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You acknowledge and agree that you buy, sell, rent or lend products entirely at your own risk. circularcouture does not endorse or guarantee any product or User of the circularcouture Offering or make any assertions as to their trustworthiness. circularcouture does not accept any liability for a party’s performance throughout the course of a Service.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          As we are not the Seller or Lender of the products, we have no control over the products and therefore do not give any commitment relating to the existence, quality, safety, genuineness or legality of a product and we hereby exclude any and all conditions, warranties, or representations both implicit or explicit relating to quality, merchantability, durability, fitness for purpose, and those arising by statute.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          We expressly exclude any and all conditions, warranties or representations both implicit or explicit and liability relating to or arising from the truth or accuracy of a Listing or any aspect thereof or any other Content made available by Users, the ability of Sellers or Lenders to sell or lend a product, the ability of a Buyer or Renter to pay for the product or to pay the Rental Price or that any party will actually complete the Service or send or return a product.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You decide whether to proceed with the Service and circularcouture shall not be liable for any delays in the delivery of a product, return of a product or any loss or damage to a product should the delivery information, address or location provided by a Member be unsecure or unsuitable.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          <strong>
            We are responsible to you for foreseeable loss and damage caused by us
          </strong>
          . If we fail to comply with these Terms, we are responsible for loss or damage you suffer that is a foreseeable result of us failing to comply with these Terms or our failing to use reasonable care and skill whilst providing the circularcouture Offering, but we are not responsible for any loss or damage that is not foreseeable. Loss or damage is foreseeable if it is either obvious that it will happen, or, if at the time the Service was entered into, both circularcouture and you knew that it might happen, for example, if you discussed it with us prior to entering into the Service.{' '}
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          <strong>
            We do not exclude or limit in any way our liability to you where it would be unlawful to do so
          </strong>
          . This includes liability for death or personal injury caused by our negligence or the negligence of our employees, agents or subcontractors or for fraud or fraudulent misrepresentation.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If we have supplied you with Content or an update to the circularcouture Platform which is defective and our failure to use reasonable care and skill causes damage to a device or digital content belonging to you, we will either repair the damage or pay you compensation for losses arising directly therefrom. However, we will not be liable for damage which you could have avoided by following our advice to apply an update offered to you free of charge or for damage which was caused by you failing to correctly follow installation instructions or to have in place the minimum system requirements advised by us.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          To the maximum extent permitted by the law, our total responsibility for any claims relating to the Service is limited to the Service Fee payable in connection with the Service.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          For any other claims arising out of the provision of the circularcouture Offering (including without limitation any dispute between Members in relation to any Content you access via the circularcouture Offering or any other Member you interact with), we do not accept any responsibility whatsoever (whether arising in contract, tort otherwise), except where, as mentioned above, we cannot disclaim, exclude or limit responsibility by law (such as death and/or personal injury caused by our negligence).
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          We are not liable for business losses, indirect losses and/or financial and business loss, or loss of goodwill or reputation. We only provide the circularcouture Offering for domestic and private use. If you use the products for any commercial, business or re-sale purpose, we will have no liability to you for any loss of profit, loss of business, business interruption, or loss of business opportunity.
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span>
            LENDER AND SELLER WARRANTIES AND REPRESENTATIONS
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          If you are a Lender or Seller, by Listing your product(s) for rent or sale on the circularcouture Platform, you warrant and represent that:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            you have read and accepted these Terms;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            you understand that circularcouture is providing you with access to the circularcouture Platform and associated platform intermediary services;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            you accept that the supply of the products is made from you to the Renter/ Buyer;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            you own or have the right to provide the product(s) to a Buyer/ Renter;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            you will not provide any product(s) that are defective or malfunction;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            you will not list any counterfeit product(s);
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            you will accept the Replacement Value set by circularcouture for any product;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            you have given a truthful and accurate description of the product’s characteristics, including but not limited to, recent photographs and an accurate Replacement Value (if applicable);
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            the products will conform to any descriptions provided, will be fit for purpose and safe to use;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            the product(s) will be professionally cleaned and delivered to the Renter or Buyer in a "ready to wear" condition and that the products will match the item description on the Listing and be a true and fair representation of their current condition;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            the information in your profile is up to date;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            you will not attempt to approach Renters or Buyers outside of the circularcouture Offering (including for the purpose of Fee Avoidance);
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            you will not engage in Fee Avoidance; and
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            ou will use a reputable courier or postal service for the purposes of delivering the product to the Renter or Buyer in a timely manner and in accordance with any dates and/or times agreed in the Service.
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You hereby acknowledge and agree that:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            circularcouture has the right to increase the Rental Fee or Purchase Price of any product you list on the circularcouture Platform based on the demand for that product or similar products;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            circularcouture has the right to increase or decrease the Rental Fee within ten percent (10%) of the original Rental Fee listed on the basis of demand for that or similar products(s);
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            you are solely responsible for complying with any obligations you have under these Terms and applicable law with respect to the products which you List on the circularcouture Platform, including giving effect to Buyers' and Renters’ rights under applicable law (including cancellation and return rights where applicable) and compensating any damage occurred by the Buyer or Renter or any other person caused by your product; and
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            you shall review the Rental Request for a product before accepting it and only accept a Rental Request where you intend to fulfil it.
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span className="c8">
            LISTINGS
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          circularcouture may perform a quality control check to ensure any Listing corresponds with the product displayed. However we shall not check whether the product or the description of the product in the Listing meets the Renter's or Buyer’s expectations. Therefore, circularcouture does not guarantee that the Renter or Buyer will find the product satisfactory, whether from an aesthetic point of view or from a practical point of view, as to its use. Any deliveries that are arranged by circularcouture and fulfilled by its delivery partners shall not imply that circularcouture is a party to the contract between the Lender and the Renter, or the Seller and Buyer (as appropriate).
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          It shall be the sole responsibility of the Lender/ Seller to respond to any claim or complaint regarding the products that they have Listed, their description, or the comments of any User about the product, the Listing or the dispatching and delivery of the products by the Lender/ Seller.
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span className="c8">
            CONTACT
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          The circularcouture Offering allows Members to directly contact each other. Buyers and Renters can gain more information about the product(s) they wish to rent or purchase, and Lenders and Sellers can gain more information about the about Buyers' and Renters' interest in product(s). Communications must comply with these Terms at all times and should not under any circumstances be used to:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            send unsolicited publicity or commercial content;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            exercise psychological pressure on another Member or send them offending content; or
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            attempt to complete a transaction outside of the circularcouture Offering for the purpose of Fee Avoidance.
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You acknowledge and accept that the circularcouture Offering is not permitted to be used for:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            contacting someone who does not want to be contacted;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            abuse or harassment;
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            concluding a transaction outside of the circularcouture Offering for the purposes of Fee Avoidance; or
          </span>
        </li>
        <li className="c100">
          <span className="c0">
            unsolicited advertising, promotions, spam or donation requests.
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You agree to contact the relevant Member directly regarding any problems you may have with the product(s) and the Service.
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span className="c8">
            REVIEWS
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          We encourage you to leave a Review of the product Renters or Buyers have purchased or rented including (without limitation) the condition of the product and overall experience. Reviews help Lenders and Sellers build a reputation on the circularcouture Platform. When providing a Review, you understand that your Review:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            will be public and visible on the Lender's account pages;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            must not include the following:
          </span>
        </li>
      </ol>
      <ul className="c33 lst-kix_list_2-0 start">
        <li className="c51">
          <span className="c0">
            personal information;
          </span>
        </li>
        <li className="c51">
          <span className="c0">
            offensive, abusive or harassing images or language;
          </span>
        </li>
        <li className="c51">
          <span className="c0">
            unnecessary or inaccurate information;
          </span>
        </li>
        <li className="c51">
          <span className="c0">
            anything intended to undermine our integrity; or
          </span>
        </li>
        <li className="c51">
          <span className="c0">
            content aimed at sabotaging the reliability of circularcouture’s Review structure.
          </span>
        </li>
      </ul>
      <p className="c17">
        <span className="c0">
          Any behaviour aimed at modifying the content of Reviews through manipulation, coercion, psychological pressuring or corruption is strictly banned.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You hereby agree and undertake not to attempt to or directly or indirectly manipulate Reviews in any way. And we reserve the right to remove any Review we believe has violated these Terms.
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span>
            DELIVERY / DISPATCH / RETURNS
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          The product(s) may be sent by circularcouture, the Lender or the Seller. If a product is dispatched directly by the Lender or Seller, the delivery timescale and tracking number shall be stated by the Lender or Seller.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0 start">
        <li className="c10">
          <span className="c8">
            DISPATCHED BY LENDER / SELLER
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          If a Lender's or Seller’s delivery carrier has used reasonable endeavours to deliver a product to the Renter or Buyer and those endeavours have proven unsuccessful, for instance, if the address provided is incorrect or incomplete or the parcel is sent back due to non-acceptance by the Renter or Buyer, the product shall be returned to the Lender or Seller.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            DISPATCHED BY circularcouture
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          All deliveries marked as "Managed" on a Listing will be sent through circularcouture’s delivery partners, which may be updated from time to time at circularcouture’s discretion. The delivery method used will be at the discretion of circularcouture.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture or its delivery partners will contact the Buyer or Renter with a tracking number that provides information about estimated delivery and arrival times of Rented products.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If circularcouture’s delivery partners have used reasonable endeavours to deliver a product to the Renter or Buyer and those endeavours have proven unsuccessful, for instance, if the address provided is incorrect or incomplete or the parcel is sent back due to non- acceptance by the Renter or Buyer, an email will be sent to the Renter or Buyer to notify them.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture disclaims any liability in the case of loss of or damage to a product while in transit to circularcouture.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            RETURNS TO circularcouture
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          This section applies to Products dispatched by circularcouture.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture will deliver the product with a prepaid, pre-addressed reusable return packaging (the "
          <strong>
            Return Packaging
          </strong>
          ") together with instructions for your use in returning the products to circularcouture. If you lose the Return Packaging, please contact us at{' '}
          <span className="c3 c13">
            <Link
              className="c9"
              to="https://help.circularcouturecollective.com/hc/en-us/requests/new"
              target="_blank"
            >
              https://help.circularcouturecollective.com/hc/en-us/requests/new
            </Link>
          </span>
          {' '}to request new Return Packaging. You hereby consent to circularcouture charging your Payment Method for the cost of the lost Return Packaging.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If a product is not returned to circularcouture in the Return Packaging provided, circularcouture may, at its sole discretion, charge you for the cost of the Return Packaging and you hereby consent to payment being taken from the Payment Method without any further notice to you.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            RETURNS TO A LENDER OR SELLER
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          This section applies to Products dispatched by a Lender / Seller
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          A product should be returned to the address indicated by the Lender/ Seller. circularcouture disclaims any liability in the case of loss of or damage to a product prior to or while in transit to a Lender/ Seller.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            DELIVERY LIABILITY
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          A product shall remain the property of the Lender, Seller or circularcouture (as applicable), unless the Product is purchased by a Buyer in which case title in the Product shall pass to the Buyer on full payment being received by circularcouture.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          The transfer of the risks of loss or damage to a product shall take place upon receipt of the product by the Renter or Buyer or by a third party that the Renter or Buyer shall have commissioned or instructed to act on their behalf. The Renter or Buyer shall therefore be liable for any damage caused to a product or the loss of a product after it has been received.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          In the event that a delay in the delivery of a product occurs and as a result you wish to cancel the Service, you hereby agree and undertake to use a reputable courier or postal service for the purposes of returning the product to circularcouture at the below address or a Lender/Seller at the address indicated by them in a timely manner and in accordance with any dates and/or times agreed in the Service:
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture Limited, 85 Great Portland Street, First Floor, London, W1W 7LT
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span>
            STOPPING USE OF THE circularcouture OFFERING
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          Save for Services which are currently in progress, you may cease using the circularcouture Offering at any time. You may delete your account by emailing us at{' '}
          <span className="c3">
            <Link
              className="c9"
              to="mailto:deleteaccount@circularcouturecollective.com"
              target="_blank"
            >
              deleteaccount@circularcouturecollective.com
            </Link>
          </span>
          . You acknowledge and agree that your Content may continue to be used and displayed by circularcouture on the circularcouture Platform even after such deactivation.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements. To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal requirements.
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span>
            GENERAL SELLER AND RENTER PERSONAL INFORMATION
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          As a User of the circularcouture Offering, you consent to us handling your personal data in accordance with the{' '}
          <span className="c3">
            <Link
              className="c9"
              to="https://www.circularcouturecollective.com/privacy-policy"
              target="_blank"
            >
              Privacy Policy
            </Link>
          </span>
          .
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          For details about which cookies are collected and how to manage cookies, please see the{' '}
          <span className="c3">
            <Link
              className="c9"
              to="https://www.circularcouturecollective.com/cookie-policy"
              target="_blank"
            >
              Cookie Policy
            </Link>
          </span>
          .
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span>
            DISPUTES
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_A-0 start">
        <li className="c10">
          <span className="c8">
            Disputes between Members:
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          If you have a dispute with another Member, you hereby agree and undertake to release us (including our agents, directors, officers and employees) from any claim, demand or damage of any kind and nature that has arisen from the dispute, both knowing and unknowing.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Members in dispute with each other must first attempt to resolve the issue via the following process:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            the disputing party must raise the issue directly with the other Member and give reasons for the dispute;
          </span>
        </li>
        <ol
          className="pl-5"
          type="a"
        >
          <li className="c100">
            <span className="c0">
              if a Member accepts the disputing party's reasons for the dispute, the Lender or Seller may resolve the issue by issuing a refund or raising a charge via their Dashboard;
            </span>
          </li>
          <li className="c100">
            <span className="c0">
              if a Renter or Buyer receives a charge from a Lender or Seller, they shall either accept or decline this charge within 5 days of notification of such charge issued by the Lender or Seller.
            </span>
          </li>
        </ol>
        <li className="c100">
          <span className="c0">
            notwithstanding the above, if you and another Member are unable to resolve the issue, circularcouture will make all reasonable efforts to mediate an equitable outcome.
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          In the event that substantial costs are incurred as a result of circularcouture’s provision of mediation services, circularcouture may invoice you for a reasonable reimbursement in respect of these costs (the "Mediation Costs").
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Disputes between you and circularcouture:
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          In the event that you have a dispute with us, please contact us directly at{' '}
          <span className="c3">
            <Link
              className="c9"
              to="https://help.circularcouturecollective.com/hc/en-us/requests/new"
              target="_blank"
            >
              https://help.circularcouturecollective.com/hc/en-us/requests/new
            </Link>
          </span>
          <span>
            {' '}so that a resolution can be found.
          </span>
        </span>
      </p>
      <ol className="c1 lst-kix_list_i2-0 start">
        <li className="c10">
          <span className="c8">
            Informal Dispute Resolution
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          Both you and circularcouture agree that in the event of a dispute, you and circularcouture will first contact the other party and make efforts in good faith to resolve the dispute before resorting to more formal means of resolution.
        </span>
      </p>
      <ol className="c1 lst-kix_list_i2-0">
        <li className="c10">
          <span className="c8">
            Formal Dispute Resolution
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          In the unlikely event that we have not been able to resolve a dispute informally, each party reserves the right to seek relief in court.
        </span>
      </p>
      <ol className="c1 lst-kix_list_1-0">
        <li className="c10">
          <span>
            General
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          These Terms constitute the entire agreement between the parties and supersedes and extinguishes all previous terms and conditions, agreements, promises, assurances, warranties, representations and understandings between us, whether written or oral, relating to the circularcouture Offering. Each party agrees that it shall have no remedies in respect of any statement, representation, assurance or warranty (whether made innocently or negligently) that is not set out in these Terms. Each party agrees that it shall have no claim for innocent or negligent misrepresentation or negligent misstatement based on any statement in these Terms.{' '}
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          No failure or delay by a party to exercise any right or remedy provided under these Terms or by law shall constitute a waiver of that or any other right or remedy, nor shall it prevent or restrict the further exercise of that or any other right or remedy. No single or partial exercise of such right or remedy shall prevent or restrict the further exercise of that or any other right or remedy.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          In the event that any part of these Terms is found by a court to be unreasonable, unenforceable or void, that part shall be severed, and the remainder of the Terms shall be enforceable with such deletion or modification as may be necessary to make it effective and for such period as is found to be reasonable and valid.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Nothing in these Terms is intended to, or shall be deemed to, establish any partnership or joint venture between any of the parties, constitute any party the agent of another party, or authorise any party to make or enter into any commitments for or on behalf of any other party. Each party confirms it is acting on its own behalf and not for the benefit of any other person.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture may at any time assign, mortgage, charge, subcontract, delegate, declare a trust over or deal in any other manner with any or all of its rights and obligations under these Terms. You shall not assign, transfer, mortgage, charge, subcontract, delegate, declare a trust over or deal in any other manner with any of your rights and obligations under this agreement.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Time is of the essence for all times, dates and periods specified in these Terms which means that any delay of performing a duty will justify termination of our agreement with you.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Any notice required to be given to circularcouture in connection with these Terms shall be in writing and must be sent by email to{' '}
          <span className="c3">
            <Link
              className="c9"
              to="https://help.circularcouturecollective.com/hc/en-us/requests/new"
              target="_blank"
            >
              https://help.circularcouturecollective.com/hc/en-us/requests/new
            </Link>
          </span>
          <span>
            .
          </span>
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Notice to you shall be sent via email to the email address provided by you at registration. Any communications shall be deemed to have been received on the next business day after sending.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Unless it expressly states otherwise, these Terms do not give rise to any rights under the Contracts (Rights of Third Parties) Act 1999.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          These Terms and any dispute or claim (including non-contractual disputes or claims) arising out of or in connection with them or their subject matter or formation shall be governed by and construed in accordance with the law of England.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Each party irrevocably agrees that the courts of England and Wales shall have exclusive jurisdiction to settle any dispute or claim (including non-contractual disputes or claims) arising out of or in connection with these Terms or its subject matter or formation.
        </span>
      </p>
      <h2
        className="c17"
        id="rental_terms"
      >
        <span className="c8">
          RENTAL TERMS
        </span>
      </h2>
      <p className="c17">
        <span className="c0">
          In addition to the General Terms, the following provisions shall apply to you whilst using the circularcouture Offering in the capacity of a Renter or Lender.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0 start lower">
        <li className="c10">
          <span className="c8">
            Condition: Use of the products
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You acknowledge and accept that use and wear of the product is entirely at your own risk and circularcouture shall not be held liable for any health-related complaints associated with any product. You agree and undertake to use best endeavours to maintain the condition of all products, we ask that you treat it as if it was your own or borrowed from a close friend.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You acknowledge and accept that you are responsible for loss, destruction or damage to a product due to theft, mysterious disappearance, fire, major stains or any other cause resulting in the loss of or irreparable damage to a product. If you have purchased Damage Protection, you shall not be liable for any damage which circularcouture considers in its sole discretion to be minor, including but not limited to, minor stains, rips, missing beads and broken or stuck zippers.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If you lose a product or return a product that is materially damaged, you agree and acknowledge that we will be entitled to charge your Payment Method with an amount per lost or damaged product up the Replacement Value of each product and you hereby consent thereto.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0 lower">
        <li className="c10">
          <span className="c8">
            Renting Services
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          If your Rental Request is accepted by a Lender, the Lender shall grant to you a limited license to use the product(s) for the duration of the Rental Period in accordance with these Terms and your agreement with the Lender.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          By submitting a Rental Request, you consent and warrant that:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            you have read the product description and accepted these Terms before making the request to rent a product;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            you understand that circularcouture is providing you with access to the circularcouture Platform and associated platform intermediary services, and that the supply of the loaned items is made to you by the Lender;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            your profile information is up-to-date;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            you will not engage in any activity which constitutes Fee Avoidance (which shall be determined by circularcouture in its sole discretion);{' '}
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            you will not attempt to approach Lenders outside of the circularcouture Offering (including for the purpose of Fee Avoidance); and
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            you have sufficient and available funds to cover the payment for the rental and any associated costs, including the Service Fee, the Security Deposit (where applicable), the Replacement Value in the event of any loss of or damage to the product and the Mediation Costs (in the event of a dispute); and
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            you will use a reputable courier or postal service and use a first-class tracked and signed for service for the purposes of returning the product to the Lender in a timely manner and in accordance with the Rental Period;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            you agree with the Replacement Value of the product provided by the Lender on the Listing and accept liability to pay the Replacement Value in circumstances of loss or damage to the product. IF YOU DO NOT AGREE WITH THE REPLACEMENT VALUE, YOU SHOULD NOT RENT THE PRODUCT; and
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            you are not doing so on behalf of any other person and you shall not allow any other individual to use the product(s). Use of the product(s) by any other individual is a breach of these Terms.
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Loss or damage
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You acknowledge and accept that in the event of any loss or damage to a product, circularcouture reserves shall be entitled to:
        </span>
      </p>
      <ol className="c1 lst-kix_list_i-0 start">
        <li className="c100">
          <span className="c0">
            retain the Security Deposit;
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            charge your Payment Method with a sum up to the Replacement Value of the product; and
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0">
        <li className="c100">
          <span className="c0">
            charge your Payment Method with the Mediation Costs.
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Fit Policy
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          If a product does not fit, a Renter has the ability to claim a part-money, part-credit refund of the Rental Fee ("
          <strong>
            Fit Policy
          </strong>
          "). The Rental Fee only will be refunded directly to the Renter’s Payment Method and the dry-cleaning fee will be credited to the Renter’s circularcouture account. Postage costs are non-refundable.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          To claim the Fit Policy, the Renter must notify circularcouture via their account dashboard on the Rental Start Date. The Renter must go to their "In Progress" rentals on the account dashboard and select "View Details" to see the "Order Summary" page. The Renter can then click on "My Item Doesn’t Fit" at the top of the page. If the rental arrives early, the "My Item Doesn’t Fit" button may not appear until the Rental Start Date.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Returns
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You acknowledge and accept that when returning a product to a Lender at the end of a Rental Period, the product must be returned in the post before 12pm (noon) on the Rental End Date. If you would like to extend the Rental Period, you may submit an extension request to the Lender via the circularcouture Platform. The Lender reserves the right to decline the request, in which case you hereby undertake to return the product to the Lender in accordance with the original Rental Period.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If the product is not returned before 12pm (noon) on the Rental End Date, you acknowledge and accept that you will be liable for all Outstanding product Fees (further details of which are provided at Section 3 of the General Terms).
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You expressly accept and acknowledge that the Lender (and not circularcouture) is responsible for ensuring that products conform to any descriptions provided on the circularcouture Platform and circularcouture is not liable for any loss suffered by you arising from your renting of any products through the circularcouture Offering.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          <strong>
            <i>
              Renter cancellation if you cancel the Rental Request
            </i>
          </strong>
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If you decide that you no longer want to rent a product, you can cancel the Rental Request free of charge by visiting the "My Rentals" section of your account on the circularcouture Platform no less than ten (10) days prior to the Rental Start Date. For example, if a Rental Start Date is the 20th day of the month, a cancellation request must be submitted to circularcouture on or before the 10th day of the month.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If you decide to cancel a Rental Request within 10 calendar days of the Rental Start Date, circularcouture reserves the right to invoice and charge your Payment Method with a Cancellation Charge. However, where your Booking Date and the Rental Start Date are within the same forty-eight (48) hour period, you shall be entitled to cancel the Rental Request free of charge within the two (2) hour period immediately following the time of the Rental Request being submitted. In all other circumstances where you cancel the rental within forty-eight (48) hours of the Rental Start Date, you shall not be entitled to any refund.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Any Security Deposit being held by circularcouture shall be returned to you within ten (10) business days of cancellation.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If we reasonably believe that you rented a product with the intention of perpetrating a theft or to cause any other harm to a User or circularcouture, we reserve the right to cancel the rental without notice and to charge your Payment Method with a sum that we deem to be appropriate, in our sole and absolute discretion, up to the sum of the Replacement Value.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            Lender cancellation
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          If a Lender cancels a confirmed Rental Request, the Renter will receive a full refund of all fees paid by them for this rental.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If a Lender cancels a rental at least 48 hours prior to the Rental Start Date, or within two (2) hours of accepting a rental with a Rental Start Date due to commence within forty-eight (48) hours, there shall be no Service Fee payable by the Lender.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          In all other events of cancellation by a Lender, circularcouture reserves the right to charge the Lender 100% of the Service Fee applicable.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture reserves the right to publish a Review indicating that the Lender has cancelled a rental Request.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture reserves the right to display the product forming the subject matter of a cancelled Rental Request as unavailable or blocked for the duration of the originally requested Rental Period.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture may impose a cancellation fee as it deems appropriate and reserves the right to "pause" wardrobes due to inactivity or repeated declined or expired rentals.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0">
        <li className="c10">
          <span className="c8">
            circularcouture Credit Loyalty Scheme
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          The circularcouture Credit Loyalty Scheme ("Loyalty Scheme") allows eligible users to earn credit for use on future rentals on the circularcouture marketplace. By participating in the Loyalty Scheme, Members agree to be bound by these terms of service, in combination to the general circularcouture Terms of Service.
        </span>
      </p>
      <ol className="c17 lst-kix_list_i-0 start m-0">
        <li className="c0">
          <span className="c8">
            Eligibility:{' '}
          </span>
          <span className="c0">
            The Loyalty Scheme is open to all registered circularcouture marketplace Members who have successfully completed rentals.
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0 m-0">
        <li className="c100">
          <span className="c8">
            Earning Credits:{' '}
          </span>
          <span className="c0">
            Users can earn credits equal to 5% of the total rental price (including dry cleaning, delivery, service fee, and damage protection costs) after other credits are applied. Credits are earned only for successful rentals; Members will not earn credits for canceled or unsuccessful rentals.
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0 m-0">
        <li className="c100">
          <span className="c8">
            Using Credits:{' '}
          </span>
          <span className="c0">
            Credits earned through the Loyalty Scheme can be applied to future rentals on the circularcouture Marketplace. To redeem credits, Members must select the option to apply their available credit balance during the checkout process. Credits cannot be used in combination with other discounts, promotions, or coupon codes.
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0 m-0">
        <li className="c100">
          <span className="c8">
            Non-Transferability:{' '}
          </span>
          <span className="c0">
            Credits earned through the Loyalty Scheme are non-transferable and can only be used by the circularcouture Member who earned them.
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0 m-0">
        <li className="c100">
          <span className="c8">
            Expiration:{' '}
          </span>
          <span className="c0">
            Currently, there is no expiration date for the earned credits. However, circularcouture reserves the right to modify or cancel the Loyalty Scheme, including the expiration terms, at any time, with or without notice.
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0 m-0">
        <li className="c100">
          <span className="c8">
            Account Termination:{' '}
          </span>
          <span className="c0">
            circularcouture reserves the right to terminate a Member’s account and/or revoke any earned credits if it is determined that the user has violated the circularcouture Terms of Service of the Loyalty Scheme.
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0 m-0">
        <li className="c100">
          <span className="c8">
            Modification:{' '}
          </span>
          <span className="c0">
            circularcouture reserves the right to modify, suspend, or terminate the Loyalty Scheme, including these terms, at any time, with or without notice. Continued participation in the Loyalty Scheme following any modifications constitutes acceptance of the revised terms and conditions.
          </span>
        </li>
      </ol>
      <ol className="c1 lst-kix_list_i-0 m-0">
        <li className="c100">
          <span className="c8">
            Liability:{' '}
          </span>
          <span className="c0">
            circularcouture is not responsible for any loss or damage incurred by Members as a result of participation in the Loyalty Scheme, including any technical issues or errors related to the calculation, crediting, or use of credits.
          </span>
        </li>
      </ol>
      <h2
        className="c17"
        id="sale_terms"
      >
        <span className="c8">
          SALE TERMS
        </span>
      </h2>
      <p className="c17">
        <span className="c0">
          In addition to the General Terms, the following provisions shall apply to you whilst using the circularcouture Offering in the capacity of Buyer or Seller.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0 start lower">
        <li className="c10">
          <span className="c8">
            Who are you buying from?
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          When you purchase any product, you will buy directly from the relevant Seller (not from us) through the circularcouture Platform and the contractual relationship in relation to the sale will be only between you and that Seller. We will not be a party to it. The relevant Seller will be responsible for the sale, the delivery (if applicable) and other after-sale care and our role is limited to acting as commercial agent to conclude the sale by collecting your payment via your chosen Payment Method on behalf of that Seller. Our receipt of full payment from you will discharge your debt to the relevant Seller in respect of your purchase. Though we may assist with certain practical issues on behalf of the relevant Seller, we do not have any contractual obligations to you and you do not have any contractual rights against us regarding any product sold on the circularcouture Platform by any Seller.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0 lower">
        <li className="c10">
          <span className="c8">
            Ordering and availability of products for sale
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          You may order products by clicking on the items you wish to purchase and then following the prompts that will appear on-screen. You may check and correct any input errors up until the point at which you purchase the Product(s) by clicking the "Buy Now" button and completing the payment process. At this point, the contract between you and the relevant Seller in relation to the product(s) ordered ("
          <strong>
            Contract
          </strong>
          ") is formed, and the Seller is under a legal duty to supply you with product(s) that are in conformity with the Contract.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0 lower">
        <li className="c10">
          <span className="c8">
            Buyer cancellation rights
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          If you purchase a Product from a Trader Seller, you have the right to cancel any purchase at any time before its delivery and up to 14 days afterwards, beginning on the day after your product (in its entirety) is delivered to you. If you cancel, you will receive a refund of the Purchase Price in accordance with the refunds policy (see below).
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If you purchase a Product from a Seller which is not a Trader Seller; the right to cancel the purchase and obtain a refund of the Purchase Price will be at circularcouture's or the relevant Seller's sole discretion.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          To cancel a purchase, you must clearly inform circularcouture (as applicable), preferably:
        </span>
      </p>
      <ul className="c33 lst-kix_list_2-0 start">
        <li className="c51">
          <span className="c0">
            by email to the following address
            <span className="c3">
              <Link
                className="c9"
                to="mailto:contact@circularcouturecollective.com"
              >
                contact@circularcouturecollective.com
              </Link>
            </span>
            , giving your name, address and order reference; and
          </span>
        </li>
        <li className="c51">
          <span className="c0">
            by completing and submitting the cancellation form included within the parcel, also available at request on the circularcouture Platform at{' '}
            <Link
              to="https://help.circularcouturecollective.com/hc/en-us/requests/new"
              target="_blank"
            >
              https://help.circularcouturecollective.com/hc/en-us/requests/new
            </Link>
          </span>
        </li>
      </ul>
      <p className="c17">
        <span className="c0">
          You must also return the product(s) within 14 days after the day you notify your cancellation, in the same condition in which you receive them (which does not interfere with your right to take any reasonable steps to examine the product(s) and make sure they conform to your order).{' '}
          <strong>
            Products must be returned to the relevant Seller or circularcouture (as applicable)
          </strong>
          . You have a legal obligation to take reasonable care of the product(s) while in your possession. If you fail to comply with this obligation, the relevant Seller may have a right to deduct the cost of any deterioration (due, for example, to your having used the product(s)), up to the price of the product(s), from the refund to which you are otherwise entitled.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          To return the product(s), you should package the parcel securely (making sure you include a note of your name and address (enclosing any returns slip, if you have been provided with one) inside the parcel) and then return it to circularcouture/the Seller (as applicable), either by courier or by recorded delivery mail or other form of certified mail or, if the product(s) are too bulky to return by mail, then by a suitable carrier, to the returns address stated in your receipt.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You are advised to take out enough postal/carriage insurance to cover the value of the contents. Please save your proof of posting/despatch and tracking information until your refund has been processed. You will be responsible for the cost and risk of returning the product(s).
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Details of the consumer rights described above, and an explanation of how to exercise them, are provided in you receipt. Nothing in this section affects your legal rights.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0 lower">
        <li className="c10">
          <span className="c8">
            Refunds policy
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          If you are a Buyer and you have cancelled your purchase from a Trader Seller, and within the 14-day cooling-off period (see above), any refund due to you will be processed as soon as possible and, in any case, within 14 days after the day on which circularcouture / the relevant Seller receives the product(s) back or, if earlier, the day on which circularcouture / the relevant Seller receive evidence that you have returned the product(s) to the returns address (see above).
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          You will be refunded the price paid in full (subject to any deduction the relevant Seller is entitled to make due to your use of or damage to the product(s)), including the cost of standard delivery. However, you will not be refunded your cost of returning the product(s). If you received any promotional or other discount when you paid, any refund will only reflect the amount you actually paid. Refunds are made using the same method originally used by you to pay for your purchase, unless agreed otherwise.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If you are a Buyer and you have purchase products from Seller who is not a Trader Seller, your right to return products will be at circularcouture's or the relevant Seller's sole discretion.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0 lower">
        <li className="c10">
          <span className="c8">
            Products not as described
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          All products for sale on the circularcouture Platform are second hand, this means that they may not be in perfect condition. However, if any product that you purchase does not comply with the description and photographs provided by the Seller, you may have one or more legal remedies available to you, depending on when you make the relevant Seller aware of the problem, in accordance with your legal rights.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          A product will be considered as not complying with the description and photographs provided by the Seller when the product received in comparison to the description and photographs is: an incorrect size, the wrong colour, a counterfeit item, severely damaged (stains, smells, holes), the wrong condition, incorrect or missing. Conversely, this will not be the cases where the product is not a right fit (but the size was correctly indicated in the listing), or the differences between the product received and the description and photographs only include minor and negligible differences that do not affect the use and look of the product as legitimately expected by the Buyer based on the description and photographs.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If you believe you received a product that does not comply with the description and photographs provided by the Seller, you should inform the relevant Seller as soon as possible, preferably in writing, giving your name, address and order reference.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Please note that we have no control over any Seller or the quality of any of the products or service it provides, we do not give any commitment (whether on our own behalf or on behalf of any Seller) regarding them, and we are not able to provide, and have no responsibility or liability for providing, any compensation to you on behalf of any Seller (other than us).
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          Nothing in this section affects your legal rights.
        </span>
      </p>
      <ol className="c1 lst-kix_list_A-0 lower">
        <li className="c10">
          <span className="c8">
            Cancellation Policy
          </span>
        </li>
      </ol>
      <p className="c17">
        <span className="c0">
          If a Seller cancels a confirmed Buyer Request, the Buyer will receive a full refund of all fees paid by them for this purchase.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          If a Seller cancels a Buyer's purchase within two (2) hours of it being made there shall be no Service Fee payable by the Seller.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          In all other events of cancellation by a Seller, circularcouture reserves the right to charge the Seller 100% of the Service Fee applicable.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture reserves the right to publish a Review indicating that the Seller has cancelled a Buyer's purchase.
        </span>
      </p>
      <p className="c17">
        <span className="c0">
          circularcouture may impose a cancellation fee as it deems appropriate and reserves the right to "pause" wardrobes due to inactivity.
        </span>
      </p>
      <p className="c17">
        <span className="c0" />
      </p>
      <p className="c17">
        <span className="c0" />
      </p>
      <p className="c17">
        <span className="c0" />
      </p>
      <p className="c17">
        <span className="c0" />
      </p>
    </div>
  </article>
  <div className="row  mx-0 mt-5 py-4">
    <div className=" col-lg-8 mx-auto d-flex justify-content-center flex-column guest-list-button">
      <h1 className="mt-2">
        <span>
          guest list
        </span>
      </h1>
      <h5 className="mt-3">
        <span>
          Join our guest list for the latest in trending and fashion                        updates.
        </span>
      </h5>
      <input
        className="mt-5"
        placeholder=" Email"
        type="text"
      />
      <Link to="/ListItems/ListStepTwo">
        {' '}
        <button className="mt-4 mb-4 btn-signup1">
          sign up
        </button>
      </Link>
    </div>
  </div>
</div>
        <EmailSubscription />
        <Footer />
        </>
    )
}

export default TermsOfService;